import { render, staticRenderFns } from "./LiveSessionInfo.vue?vue&type=template&id=3c3464d6&scoped=true&"
import script from "./LiveSessionInfo.vue?vue&type=script&lang=js&"
export * from "./LiveSessionInfo.vue?vue&type=script&lang=js&"
import style0 from "./LiveSessionInfo.vue?vue&type=style&index=0&id=3c3464d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3464d6",
  null
  
)

export default component.exports